import PropTypes from 'prop-types';
import React from 'react';
import NoteIcon from 'components/NoteIcon';
import './CountDisplay.scss';

CountDisplay.propTypes = {
  count: PropTypes.number.isRequired,
  items: PropTypes.string,
  maxDisplayCount: PropTypes.number,
};

CountDisplay.defaultProps = {
  items: 'items',
  maxDisplayCount: 500,
};

function formatCountDisplay(count, items, maxDisplayCount) {
  if (count > maxDisplayCount) {
    return { displayText: `${maxDisplayCount}+`, needsTooltip: true, tooltipText: `${count} total ${items}` };
  }
  return { displayText: count.toString(), needsTooltip: false, tooltipText: null };
}

function CountDisplay({ count, items, maxDisplayCount }) {
  const countDisplay = formatCountDisplay(count, items, maxDisplayCount);

  if (countDisplay.needsTooltip) {
    return (
      <NoteIcon showIcon={false} text={countDisplay.displayText}>
        {countDisplay.tooltipText}
      </NoteIcon>
    );
  }

  return <span className="countDisplay">{countDisplay.displayText}</span>;
}

export default CountDisplay;
